import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CustomLocation } from './location.custom';

@Injectable({ providedIn: 'root' })
export class LocationService {
	constructor(private readonly router: Router) {}
	go(delta: number, urlReplacement?: string) {
		if (delta >= 0) {
			throw new Error('we should only go back in history');
		}
		if (CustomLocation.IS_INITIAL_GLOBAL_STATE()) {
			const url = urlReplacement || '/';
			this.router.navigate([url], { replaceUrl: true }).catch((err: unknown) => {
				console.error(`error while coming back to ${ url }`, err);
			});
			return;
		}
		if (urlReplacement !== undefined) {
			sessionStorage.setItem('copoUrlRedirect', urlReplacement);
		}
		history.go(delta);
	}

	back(urlReplacement?: string) {
		if (CustomLocation.IS_INITIAL_GLOBAL_STATE()) {
			const url = urlReplacement || '/';
			this.router.navigate([url], { replaceUrl: true }).catch((err: unknown) => {
				console.error(`error while coming back to ${ url }`, err);
			});
			return;
		}
		if (urlReplacement !== undefined) {
			sessionStorage.setItem('copoUrlRedirect', urlReplacement);
		}
		history.back();
	}
}
